import { render } from "./CompaniesChat.vue?vue&type=template&id=370323b5&scoped=true"
import script from "./CompaniesChat.vue?vue&type=script&lang=js"
export * from "./CompaniesChat.vue?vue&type=script&lang=js"

import "./CompaniesChat.vue?vue&type=style&index=0&id=370323b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370323b5"]])

export default __exports__